import Img from '@/components/Img';
import styles from './Personalization.module.scss';
import Button, { ButtonType } from '@/components/Button/Button';
import Text from '@/components/Text/Text';

interface IPersonalization {
  title: string,
  button: {
    id: number;
    title: string;
    type: ButtonType;
    link: string;
    iconName?: string;
  },
  cards: {
    id: number,
    title: string,
    description: string,
    icon: {
      id: number,
      alternativeText: string | null,
      width: number,
      height: number,
      url: string,
    }
  }[]
}

const Personalization = ({ data }: { data: IPersonalization }) => (
  <section className={styles.personalization}>
    <Text tag='h2'>{data.title}</Text>

    <ul className={styles.personalization_list}>
      {data.cards.map((card) => (
        <li
          className={styles.personalization_card}
          key={card.id}
        >
          <Img
            src={card.icon.url}
            height={80}
            width={80}
            alt={card.icon.alternativeText || ''}
          />
          <Text tag='h4'>{card.title}</Text>
          <p>{card.description}</p>
        </li>
      ))}
    </ul>
    {data.button && (
      <div className={styles.primaryButtonContainer}>
        <Button
          type={data.button.type}
          href={data.button.link}
          iconName={data.button.iconName}
        >
          {data.button.title}
        </Button>
      </div>
    )}
  </section>
);

export default Personalization;
